(function () {
  'use strict';
  angular.module('clientDashboardApp').directive('accountValidation', accountValidation);
  function accountValidation(){
      return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
          function validate(viewValue){
            if (viewValue=="all") {
              ctrl.$setValidity('string', false);
            } else {
              ctrl.$setValidity('string', true);
            }
            return viewValue;
          };
          ctrl.$parsers.unshift(validate);
          ctrl.$formatters.unshift(validate);
        }
      };
    }

}());
